import React, { lazy, Suspense } from 'react';
import cn from 'classnames';
import LazyImage from 'components/UI/LazyImage';
import Link from 'components/UI/Link';
import Wrapper from './Wrapper';
import { useStateModal } from 'utils/hooks';

import * as styles from './IconItem.module.scss';

const CertificateModal = lazy(() => import('components/Modals/CertificateModal'));

export default function IconItem({ images, modalData, name, showName, theme, link, mods }) {
  const { preview, modalWindow: imgForModal, alt } = images;
  const { modalState, showModal, hideModal } = useStateModal();

  const preparedAlt = alt ?? name ?? modalData?.title ?? 'certificate';
  const shouldShowModal = Boolean(modalData?.title);

  const image = <LazyImage src={preview} className={styles.img} alt={preparedAlt} />;

  if (!shouldShowModal && link) {
    return (
      <Link href={link} className={styles.link}>
        <Wrapper name={name} showName={showName} mods={mods}>
          {image}
        </Wrapper>
      </Link>
    );
  }

  return (
    <Wrapper
      className={cn(shouldShowModal && styles.link, styles[theme])}
      name={name}
      showName={showName}
      mods={mods}
      onClick={showModal}
      role={shouldShowModal ? 'button' : undefined}
    >
      {image}
      {shouldShowModal && (
        <Suspense fallback={null}>
          <CertificateModal
            isOpen={modalState.isOpen}
            closeModalCallback={hideModal}
            img={imgForModal ?? preview}
            link={link}
            {...modalData}
          />
        </Suspense>
      )}
    </Wrapper>
  );
}
